export default __webpack_public_path__ + "static/media/Tiger's Boots of the Second Caste.68c49c1c.jpg";